<div class="nav-category">
    <div [ngClass]="[horizontalWrap? 'horizontal-wrap': 'horizontal-scroll', displaySize]">
        <a *ngFor="let cat of navCategories$ | async; trackBy: trackByFn" [routerLink]="[CATALOG_ROUTE, cat.id]"
           class="nav-category-icon">
            <img [src]="cat.imagePath" alt="">
            <h3 class="heading-4" [translate]="cat.translationTag" [useLocaleOverride]="useLocaleOverride"></h3>
        </a>
    </div>
</div>

